import axios from "axios";
import config from "./constants/appConfig";

const baseAuthURL = config.baseAuthURL;
const baseAuthURLKeycloak = config.baseAuthURLKeycloak;
const baseURL = config.baseURL;
const baseURLCadastro = config.baseURLCadastro;
const baseURLApproval = config.baseURLApproval;
const appId = config.appId;
const appKey = config.appKey;
const username = config.username;
const password = config.password;
const usernameQuotation = config.usernameQuotation;
const passwordQuotation = config.passwordQuotation;
const storageAuthName = config.storageAuthName;
const storageAuthNameQuotation = config.storageAuthNameQuotation;

const userAuth = {
  Cadastro: 1,
  Cotacao: 2
}
const clientIdApproval = config.clientIdApproval;
const clientSecretApproval = config.clientSecretApproval;
const storageAuthNameApproval = config.storageAuthNameApproval;

const AxiosAuth = axios.create({
  baseURL: baseAuthURL,
  timeout: 100000,
  responseType: "json",
});

const AxiosAuthKeycloak = axios.create({
  baseURL: baseAuthURLKeycloak,
  timeout: 100000,
  responseType: "json",
});

const Axios = axios.create({
  baseURL: baseURL,
  timeout: 100000,
  responseType: "json",
});

const AxiosCadastro = axios.create({
  baseURL: baseURLCadastro,
  timeout: 100000,
  responseType: "json",
});

const AxiosQuotation = axios.create({
  baseURL: baseURL,
  timeout: 100000,
  responseType: "json",
});

//Request Auth Interceptor
AxiosQuotation.interceptors.request.use(async (config) => {
  try {
    let authData = await getLocalToken(userAuth.Cotacao);
    if (!authData || !authData.access_token) {
      let { data } = await token(usernameQuotation, passwordQuotation, userAuth.Cotacao);
      authData = data;
    }
    config.headers.Authorization = "Bearer " + authData.access_token;
  } catch (error) {
    console.error(error);
  }
  return config;
});

const AxiosApproval = axios.create({
  baseURL: baseURLApproval,
  timeout: 100000,
  responseType: "json", 
});

//Response Error Interceptor
const axiosQuotationId = AxiosQuotation.interceptors.response.use(
  async (response) => {
    return response;
  },
  (error) => {
    let code = error && error.response ? error.response.status : -1;
    let message = messageError(code);
    if (code === 401) {
      // AxiosQuotation.interceptors.response.eject(axiosQuotationId);
      const refreshCall = refreshAuthLogic(usernameQuotation, passwordQuotation, userAuth.Cotacao);
      const requestQueueInterceptorId = AxiosQuotation.interceptors.request.use(
        (request) => refreshCall.then(() => request)
      );
      return refreshCall
        .then((tokenRefreshResponse) => {
          error.response.config.headers["Authorization"] =
            "Bearer " + tokenRefreshResponse.data.access_token;
            AxiosQuotation.interceptors.request.eject(requestQueueInterceptorId);
          return axios(error.response.config);
        })
        .catch((error) => {
          AxiosQuotation.interceptors.request.eject(requestQueueInterceptorId);
          return Promise.reject(error);
        });
    }

    if (code !== 401) {
      if (
        error.response.data &&
        error.response.data.ExceptionType === "TWCore.Util.TWCoreWarning"
      ) {
        message =
        error.response.data && error.response.data.ExceptionMessage
          ? error.response.data.ExceptionMessage
          : message;

        error.message = message;
        error.type = error.response.data.ExceptionType;
      }       
    }
    console.error(message);
   
    return Promise.reject(error);
  }
);

const getLocalToken = (userauth = userAuth.Cadastro) => {
  return Promise.resolve(
    (userauth === userAuth.Cadastro ? JSON.parse(window.sessionStorage.getItem(storageAuthName)) : JSON.parse(window.sessionStorage.getItem(storageAuthNameQuotation))) 
    || {}
  );
};

const getLocalTokenApproval = () => {
  return Promise.resolve(
    JSON.parse(window.sessionStorage.getItem(storageAuthNameApproval)) || {}
  );
};

//Request Auth Interceptor
AxiosApproval.interceptors.request.use(async (config) => {
  try {
    let authData = await getLocalTokenApproval();
    if (!authData || !authData.access_token) {
      let { data } = await tokenApproval();
      authData = data;
    }
    config.headers.Authorization = "Bearer " + authData.access_token;
  } catch (error) {
    console.error(error);
  }
  return config;
});

//Response Error Interceptor
const axiosApprovalId = AxiosApproval.interceptors.response.use(
  async (response) => {
    return response;
  },
  (error) => {
    let code = error && error.response ? error.response.status : -1;
    let message = messageError(code);
    if (code === 401) {
      // AxiosApproval.interceptors.response.eject(axiosApprovalId);
      const refreshCall = refreshAuthLogicApproval();
      const requestQueueInterceptorId = AxiosApproval.interceptors.request.use(
        (request) => refreshCall.then(() => request)
      );
      return refreshCall
        .then((tokenRefreshResponse) => {
          error.response.config.headers["Authorization"] =
            "Bearer " + tokenRefreshResponse.data.access_token;
          AxiosApproval.interceptors.request.eject(requestQueueInterceptorId);
          return axios(error.response.config);
        })
        .catch((error) => {
          AxiosApproval.interceptors.request.eject(requestQueueInterceptorId);
          return Promise.reject(error);
        });
    }

    if (code !== 401) {
      if (error.response && error.response.data) {
        error.message = error.response.data ? error.response.data : message;
      }       
    }
    console.error(error.message);

    return Promise.reject(error);
  }
);

AxiosCadastro.interceptors.request.use(async (config) => {
  try {
    let authData = await getLocalToken();
    if (!authData || !authData.access_token) {
      let { data } = await token();
      authData = data;
    }
    config.headers.Authorization = "Bearer " + authData.access_token;
  } catch (error) {
    console.error(error);
  }
  return config;
});

//Response Error Interceptor
const axiosCadastroId = AxiosCadastro.interceptors.response.use(
  async (response) => {
    return response;
  },
  (error) => {
    let code = error && error.response ? error.response.status : -1;
    let message = messageError(code);
    if (code === 401) {
      // AxiosCadastro.interceptors.response.eject(axiosCadastroId);
      const refreshCall = refreshAuthLogic();
      const requestQueueInterceptorId = AxiosCadastro.interceptors.request.use(
        (request) => refreshCall.then(() => request)
      );
      return refreshCall
        .then((tokenRefreshResponse) => {
          error.response.config.headers["Authorization"] =
            "Bearer " + tokenRefreshResponse.data.access_token;
          AxiosCadastro.interceptors.request.eject(requestQueueInterceptorId);
          return axios(error.response.config);
        })
        .catch((error) => {
          AxiosCadastro.interceptors.request.eject(requestQueueInterceptorId);
          return Promise.reject(error);
        });
    }

    if (code !== 401) {
      if (
        error.data &&
        error.data.ExceptionType === "TWCore.Util.TWCoreWarning"
      )
        message =
          error.data && error.data.ExceptionMessage
            ? error.data.ExceptionMessage
            : message;
    }
    console.error(message);

    return Promise.reject(error);
  }
);

//Request Auth Interceptor
Axios.interceptors.request.use(async (config) => {
  try {
    let authData = await getLocalToken();
    if (!authData || !authData.access_token) {
      let { data } = await token();
      authData = data;
    }
    config.headers.Authorization = "Bearer " + authData.access_token;
  } catch (error) {
    console.error(error);
  }
  return config;
});

//Response Error Interceptor
const axiosId = Axios.interceptors.response.use(
  async (response) => {
    return response;
  },
  (error) => {
    let code = error && error.response ? error.response.status : -1;
    let message = messageError(code);
    if (code === 401) {
      // Axios.interceptors.response.eject(axiosId);
      const refreshCall = refreshAuthLogic();
      const requestQueueInterceptorId = Axios.interceptors.request.use(
        (request) => refreshCall.then(() => request)
      );
      return refreshCall
        .then((tokenRefreshResponse) => {
          error.response.config.headers["Authorization"] =
            "Bearer " + tokenRefreshResponse.data.access_token;
          Axios.interceptors.request.eject(requestQueueInterceptorId);
          return axios(error.response.config);
        })
        .catch((error) => {
          Axios.interceptors.request.eject(requestQueueInterceptorId);
          return Promise.reject(error);
        });
    }

    if (code !== 401) {
      if (
        error.response.data &&
        error.response.data.ExceptionType === "TWCore.Util.TWCoreWarning"
      ) {
        message =
        error.response.data && error.response.data.ExceptionMessage
          ? error.response.data.ExceptionMessage
          : message;

        error.message = message;
        error.type = error.response.data.ExceptionType;
      }       
    }
    console.error(message);
   
    return Promise.reject(error);
  }
);

const token = async (user = username, pass = password, userauth = userAuth.Cadastro) => {
  let options = {
    headers: {
      "Content-Type": "application/x-www-form-urlencoded",
      Authorization: "Basic " + btoa(appId + ":" + appKey),
      KeepConnected: false,
    },
  };

  let data =
    "grant_type=password&username=" +
    encodeURIComponent(user) +
    "&password=" +
    encodeURIComponent(pass);

  const response = await AxiosAuth.post("/token", data, options);
  if (userauth === userAuth.Cadastro) {
    window.sessionStorage.setItem(storageAuthName, JSON.stringify(response.data));
  } else {
    window.sessionStorage.setItem(storageAuthNameQuotation, JSON.stringify(response.data));
  } 
  return response;
};

const tokenApproval = async () => {
  let options = {
    headers: {
      "Content-Type": "application/x-www-form-urlencoded"
    },
  };

  let data =
    "grant_type=client_credentials&client_id=" +
    encodeURIComponent(clientIdApproval) +
    "&client_secret=" +
    encodeURIComponent(clientSecretApproval) +
    "&scope=offline_access";

  const response = await AxiosAuthKeycloak.post("/token", data, options);

  window.sessionStorage.setItem(storageAuthNameApproval, JSON.stringify(response.data));

  return response;
};

const refreshAuthLogic = (user = username, pass = password, userauth = userAuth.Cadastro) =>
  token(user, pass, userauth).then((tokenRefreshResponse) => Promise.resolve(tokenRefreshResponse));

const refreshAuthLogicApproval = () =>
  tokenApproval().then((tokenRefreshResponse) => Promise.resolve(tokenRefreshResponse));

const messageError = (code) => {
  switch (code) {
    case -1:
      return "Falha ao acessar o servidor. Verifique sua internet.";
    case 401:
      return "Serviço não autorizado. Verifique se você tem permissão para acessar esse recurso.";
    case 404:
      return "Serviço não localizado. Talvez ele esteja apenas indisponível.";
    default:
      return "Falha na chamada do serviço.";
  }
};

export { Axios, AxiosCadastro, AxiosQuotation, AxiosApproval };
